let mm = gsap.matchMedia();

mm.add("(min-width: 780px)", () => {
  const { innerHeight } = window;
  gsap.registerPlugin(ScrollTrigger);

  /* Slogen anima */
  const slogan = gsap.timeline();
  slogan.from("#slogan-klein", { y: "-25vh", scale: 2, opacity: 0 });

  /*ScrollTrigger.create({
    animation: slogan,
    trigger: ".header",
    start: "+=100vh",
    end: "+=300",
    scrub: true,
  });*/

  const sloganGross = gsap.from("#slogan-head", {
    opacity: 0,
  });

  /*ScrollTrigger.create({
    animation: sloganGross,
    trigger: ".header",
    start: "+=500vh",
    scrub: true,
     markers: true 
  });*/

  /* Ende Slogan anima*/

  /* Bild wechseln */
  const tlbild = gsap.timeline();
  //tlbild.from(".bild-1", { xPercent: -100 })
  tlbild
    .from(".bild-2", { xPercent: 100 })
    .from(".bild-3", { yPercent: 100 })
    .from(".bild-4", { xPercent: -100 });

  /*ScrollTrigger.create({
    animation: tlbild,
    trigger: "#cont",
    start: "top top",
    end: "+=4000",
    scrub: true,
    pin: true,
    anticipatePin: 1,
  });*/
  /*Ende Bild wechseln*/

  const details = gsap.utils.toArray(
    ".desktopContentSection:not(:first-child)"
  );
  const photos = gsap.utils.toArray(".desktopPhoto:not(:first-child)");
  gsap.set(photos, { yPercent: 101 });
  /*ScrollTrigger.create({
    trigger: ".gallery",
    start: "top top",
    end: "bottom bottom",
    pin: ".right",
  });*/

  details.forEach((detail, index) => {
    let headline = detail.querySelector("h1");
   /* ScrollTrigger.create({
      trigger: headline,
      start: "top 80%",
      end: "top 50%",
      animation: gsap.to(photos[index], { yPercent: 0 }),
      scrub: true,
      markers: false,
    });*/
  });
  /* End Splitscroll*/
  /*Horizontal Scroll */
  let sections = gsap.utils.toArray(".panel");

  /*gsap.to(sections, {
    xPercent: -100 * (sections.length - 1),
    ease: "none",
    scrollTrigger: {
      trigger: ".container",
      pin: true,
      scrub: 1,
      snap: (value) => {
        let snapPoint =
          Math.round(value * (sections.length - 1)) / (sections.length - 1);
        return value > snapPoint + 0.1
          ? snapPoint + 1 / (sections.length - 1)
          : snapPoint;
      }, // Snapt erst auf die nächste Kachel, wenn sie schon größtenteils zu sehen ist
      end: "+=7500",
      markers: false,
    },
  });*/

  /* End Horizontal Scroll*/
  return () => {
    console.log("mobil");
  };
});
//mm.revert();

/* Heder-Video */
const video = document.querySelector(".homepage-video");
const playButton = document.querySelector("#play-toggle");
const audioButton = document.querySelector("#audio-toggle");

playButton?.addEventListener("click", () => {
  if (video.paused) {
    video.play();
    playButton?.classList.add("fa-circle-pause");
    playButton?.classList.remove("fa-circle-play");
  } else {
    video.pause();
    playButton?.classList.add("fa-circle-play");
    playButton?.classList.remove("fa-circle-pause");
  }
});
audioButton?.addEventListener("click", () => {
  if (video.muted) {
    video.muted = false;
    audioButton.classList.add("fa-volume-up");
    audioButton.classList.remove("fa-volume-mute");
  } else {
    video.muted = true;
    audioButton.classList.add("fa-volume-mute");
    audioButton.classList.remove("fa-volume-up");
  }
});
document.addEventListener("scroll", () => {
  // Wenn die Seite nicht ganz nach oben gescrollt ist, pausiere das Video
  if (window.scrollY > 0) {
    video.pause();
    playButton?.classList.add("fa-circle-play");
    playButton?.classList.remove("fa-circle-pause");
  } else {
    video.play();
    playButton?.classList.add("fa-circle-pause");
    playButton?.classList.remove("fa-circle-play");
  }
});

/* Podcast-Player */
function showHeaderPodcast() {
  video.addEventListener("ended", function () {
    const podcastElement = document.querySelector("#podcast-1");
    podcastElement.style.opacity = 1;
  });
}
// showHeaderPodcast();


function startPodcast(id) {
  const figure = document.querySelector("#" + id);
  const button = figure.querySelector("button");
  console.log(button);
  const playerDiv = figure.querySelector("div.audioplayer");
  const player = playerDiv.querySelector("audio");
  console.log(player);
  button.style.display = "none";
  playerDiv.style.display = "block";
  player.play();
}
/* Ende Podcast-Player */
